import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { onGetDealCategory, onGetDealCategoryAsync, onGetDealCategoryError, onGetDealCategorySuccess } from "../Store/Slices/dealCategorySlice";
import { callDealCategoryGetApi } from "../Context/dealCategoryApi";
function* GetDealCategory({ payload }) {
  try {
    const getDealCategoryResponse = yield call(callDealCategoryGetApi, payload);
    if (getDealCategoryResponse.responseCode === "200") {
      yield put(
        onGetDealCategorySuccess({
          data: getDealCategoryResponse.response,
          message: getDealCategoryResponse.responseMessage,
          status_code: getDealCategoryResponse.responseCode
        })
      );
    } else {
      yield put(
        onGetDealCategoryError({
          data: getDealCategoryResponse.response,
          message: getDealCategoryResponse.response.message,
          status_code: getDealCategoryResponse.responseCode
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(onGetDealCategoryError({ data: [], message, status_code: 400 }));
  }
}
function* GetDealCategoryAsync({ payload }) {
  try {
    const getDealCategoryResponse = yield call(callDealCategoryGetApi, payload?.payload);
    if (getDealCategoryResponse.responseCode === "200") {
      yield put(
        onGetDealCategorySuccess({
          data: getDealCategoryResponse.response,
          message: getDealCategoryResponse.responseMessage,
          status_code: getDealCategoryResponse.responseCode
        })
      );
      payload?.resolve(getDealCategoryResponse.response);
      return;
    } else {
      yield put(
        onGetDealCategoryError({
          data: getDealCategoryResponse.response,
          message: getDealCategoryResponse.response.message,
          status_code: getDealCategoryResponse.responseCode
        })
      );
      // FORCE RESOLVE (do NOT reject)
      payload?.resolve?.(null);
      return;
      // payload?.reject(getDealCategoryResponse);
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(onGetDealCategoryError({ data: [], message, status_code: 400 }));
    // RESOLVE EVEN ON EXCEPTION
    payload?.resolve?.(null);
    return;
    // payload?.reject(error);
  }
}
export default function* dealCategorySaga() {
  yield takeLatest(onGetDealCategory.type, GetDealCategory);
  yield takeEvery(onGetDealCategoryAsync.type, GetDealCategoryAsync);
}
